import React, { useEffect, useState } from "react";
import { FiChevronDown, FiSettings } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import menuItems from "../MenuList";
import { usePermission } from "../../permission/PermissionContext";

const HeaderMenu: React.FC<{ mobile?: boolean; onClose?: () => void }> = ({ mobile = false, onClose }) => {
  const [openMenus, setOpenMenus] = useState<string[]>([]);

  const menuPermissions: Record<string, boolean | "loading"> = {
    analytics_dashboard: usePermission("analytics_dashboard"),
    task_list: usePermission("task_list"),
    todo_list: usePermission("todo_list"),
    task_configuration: usePermission("task_configuration"),
  };

  const toggleDropdown = (label: string) => {
    setOpenMenus((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    );
  };

  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!(target as HTMLElement).closest(".dropdown-trigger")) {
        setOpenMenus([]);
      }
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  }, []);

  const renderMenu = (items: any[], level = 0) => {
    return items.map((item, index) => (
      <span
        key={`${item.label}-${index}`}
        className={`relative links py-2 me-3 flex ${level > 0 ? "pl-4" : ""}`}
      >
        <NavLink
          style={({ isActive }) => ({ color: isActive ? "#6c5ffc" : "#7b8191" })}
          className="flex items-center justify-between w-full dropdown-trigger"
          onClick={() => {
            if (item.subMenu) { toggleDropdown(item.label); } else { onClose && onClose(); }
          }}
          to={item.path || "#"}
        >
          <span className="flex items-center gap-2 text-[15px]">
            {item.icon} {item.label}
          </span>
          {item.subMenu && (
            <FiChevronDown
              className={`subMenuArw ${
                openMenus.includes(item.label)
                  ? level === 1 ? "-rotate-90" : "rotate-180"
                  : ""
              }`}
            />
          )}
        </NavLink>
        {item.subMenu && (
          <div
            className={`subMenu drop-shadow absolute bg-white ${
              level === 0 ? "top-full left-0 mt-4 ml-0" : "top-0 left-full mt-0 ml-4"
            } w-40 rounded ${openMenus.includes(item.label) ? "block" : "hidden"}`}
          >
            {renderMenu(item.subMenu, level + 1)}
          </div>
        )}
      </span>
    ));
  };

  const visibleMenuItems = menuItems.filter((item) =>
    item.permissionKey ? menuPermissions[item.permissionKey] === true : true
  );

  return (
    <nav className={mobile ? "flex flex-col gap-2" : "navigation_cs hidden lg:flex items-center mr-auto ms-10 gap-6"}>
      {renderMenu(visibleMenuItems)}

      {/* Task Flow Configuration — gated by task_configuration permission only */}
      {menuPermissions.task_configuration === true && (
        <span className="relative links py-2 me-3 flex">
          <NavLink
            to="/settings"
            style={({ isActive }) => ({ color: isActive ? "#6c5ffc" : "#7b8191" })}
            className="flex items-center gap-2 dropdown-trigger"
            onClick={() => onClose && onClose()}
          >
            <span className="flex items-center gap-2 text-[15px]">
              <FiSettings /> Configuration
            </span>
          </NavLink>
        </span>
      )}
    </nav>
  );
};

export default HeaderMenu;